var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEhr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9989 37.4531V49.0598M57.5996 43.3854H44.2804M82.0781 38.6042V87.25C82.0781 88.3546 81.1827 89.25 80.0781 89.25H21.9219C20.8173 89.25 19.9219 88.3546 19.9219 87.25V21.125C19.9219 20.0204 20.8173 19.125 21.9219 19.125H80.0781C81.1827 19.125 82.0781 20.0204 82.0781 21.125V38.6042Z",
    stroke: "#1778E1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7344 60.5625H34.2656",
    stroke: "#1778E1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7344 73.3125H34.2656",
    stroke: "#1778E1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7656 14.3438H70.9219V25.5H31.0781V14.3438H42.2344C42.2344 9.06253 46.1589 4.78125 51 4.78125C55.8411 4.78125 59.7656 9.06253 59.7656 14.3438Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7656 14.3438H57.7656C57.7656 15.4483 58.6611 16.3438 59.7656 16.3438V14.3438ZM70.9219 14.3438H72.9219C72.9219 13.2392 72.0264 12.3438 70.9219 12.3438V14.3438ZM70.9219 25.5V27.5C72.0264 27.5 72.9219 26.6046 72.9219 25.5H70.9219ZM31.0781 25.5H29.0781C29.0781 26.6046 29.9736 27.5 31.0781 27.5V25.5ZM31.0781 14.3438V12.3438C29.9736 12.3438 29.0781 13.2392 29.0781 14.3438H31.0781ZM42.2344 14.3438V16.3438C43.3389 16.3438 44.2344 15.4483 44.2344 14.3438H42.2344ZM59.7656 16.3438H70.9219V12.3438H59.7656V16.3438ZM68.9219 14.3438V25.5H72.9219V14.3438H68.9219ZM70.9219 23.5H31.0781V27.5H70.9219V23.5ZM33.0781 25.5V14.3438H29.0781V25.5H33.0781ZM31.0781 16.3438H42.2344V12.3438H31.0781V16.3438ZM44.2344 14.3438C44.2344 9.99973 47.4237 6.78125 51 6.78125V2.78125C44.8941 2.78125 40.2344 8.12533 40.2344 14.3438H44.2344ZM51 6.78125C54.5763 6.78125 57.7656 9.99973 57.7656 14.3438H61.7656C61.7656 8.12533 57.1059 2.78125 51 2.78125V6.78125Z",
    fill: "#1778E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhr);
export default __webpack_public_path__ + "static/media/EHR.a054b173.svg";
export { ForwardRef as ReactComponent };